import { TFunction } from 'i18next'

import { InvoiceLineType } from '@features/invoices/enums/invoiceLineType'
import { InvoiceFormRowLine } from '@features/invoices/types/invoiceForm/invoiceFormLine/invoiceFormRowLine'

import { DemoInvoiceProduct } from '../types/demoInvoiceProduct'

export const getDemoInvoiceRowLine = (product: DemoInvoiceProduct, t: TFunction, quantity = 1): InvoiceFormRowLine => ({
  date: new Date(),
  discount: 0,
  productName: t(product.tName),
  productType: product.productType,
  quantity,
  totalExcludingVat: 0,
  totalIncludingVat: 0,
  type: InvoiceLineType.Row,
  unit: product.unit,
  unitPrice: product.unitPrice,
  vatRateId: undefined,
  vatRatePercent: product.vatRatePercent,
})
